"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _excluded = ["className", "unit", "value", "onChange"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStylesSearchBar = function useStylesSearchBar(unit) {
  return (0, _styles.makeStyles)(function (theme) {
    var _root;

    return {
      root: (_root = {
        flexGrow: 2,
        transition: 'flex-basis 500ms ease-in-out',
        border: "".concat(Math.ceil(unit / 3), "px solid #e2e2e1"),
        overflow: 'hidden',
        borderRadius: unit * 2,
        margin: 0,
        marginTop: unit,
        marginBottom: unit,
        maxWidth: 1200,
        width: '60vw',
        backgroundColor: '#fcfcfb',
        fontSize: unit * 2,
        padding: unit / 2
      }, _defineProperty(_root, "transition", theme.transitions.create(['border-color', 'box-shadow'])), _defineProperty(_root, "fontWeight", 500), _defineProperty(_root, '&:hover', {
        backgroundColor: '#fff'
      }), _defineProperty(_root, '&$focused', {
        color: theme.palette.primary.main,
        backgroundColor: '#fff',
        // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
        borderColor: '#666'
      }), _root),
      input: {
        textTransform: 'uppercase'
      },
      focused: {},
      icon: {
        margin: unit
      },
      toggleWrapper: {
        height: 'auto'
      }
    };
  })();
};

function SearchBar(_ref) {
  var className = _ref.className,
      unit = _ref.unit,
      value = _ref.value,
      _onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStylesSearchBar(unit);
  return /*#__PURE__*/_react["default"].createElement(_core.TextField, _extends({
    InputProps: _objectSpread({
      classes: classes,
      className: className,
      disableUnderline: true,
      startAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "start",
        className: classes.icon
      }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
        color: "inherit",
        fontSize: unit > 20 ? 'large' : 'small'
      }))
    }, value.length > 0 ? {
      endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        color: "inherit",
        onClick: function onClick() {
          return _onChange('');
        }
      }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        color: "inherit",
        fontSize: unit > 20 ? 'large' : 'small'
      })))
    } : {}),
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    },
    value: value
  }, props));
}

var _default = SearchBar;
exports["default"] = _default;